import { FC } from 'react';
import { BookOpenCheck, GraduationCap, Crown } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface LessonHeaderProps {
  title: string;
  level?: 'principiante' | 'intermedio' | 'avanzado';
  isPremium?: boolean;
}

const getLevelInSpanish = (level?: string) => {
  if (!level) return 'Principiante';
  
  const levels = {
    'principiante': 'Principiante',
    'intermedio': 'Intermedio',
    'avanzado': 'Avanzado'
  };
  return levels[level as keyof typeof levels] || 'Principiante';
};

export const LessonHeader: FC<LessonHeaderProps> = ({ 
  title, 
  level, 
  isPremium 
}) => {
  return (
    <div className="mb-8 text-center space-y-4 animate-fade-in">
      <div className="flex items-center justify-center space-x-2">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
          {title}
        </h1>
      </div>
      
      <div className="flex items-center justify-center gap-4">
        <div className="flex items-center space-x-2 bg-primary/10 px-4 py-2 rounded-full">
          <GraduationCap className="h-5 w-5 text-primary" />
          <span className="text-primary font-medium">
            Nivel: {getLevelInSpanish(level)}
          </span>
        </div>
        {isPremium ? (
          <div className="flex items-center space-x-2 bg-yellow-100 px-4 py-2 rounded-full">
            <Crown className="h-5 w-5 text-yellow-600" />
            <span className="text-yellow-700 font-medium">Premium</span>
          </div>
        ) : (
          <div className="flex items-center space-x-2 bg-green-100 px-4 py-2 rounded-full">
            <BookOpenCheck className="h-5 w-5 text-green-600" />
            <span className="text-green-700 font-medium">Free</span>
          </div>
        )}
      </div>
    </div>
  );
};